/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invoice_Reader_Not_ConfiguredInputs */

const fr_api_invoice_reader_not_configured = /** @type {(inputs: Api_Invoice_Reader_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’analyse des factures n’est pas configurée. Contactez un administrateur.`)
};

const en_api_invoice_reader_not_configured = /** @type {(inputs: Api_Invoice_Reader_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice analysis is not configured. Contact an administrator.`)
};

/**
* | output |
* | --- |
* | "Invoice analysis is not configured. Contact an administrator." |
*
* @param {Api_Invoice_Reader_Not_ConfiguredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invoice_reader_not_configured = /** @type {((inputs?: Api_Invoice_Reader_Not_ConfiguredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invoice_Reader_Not_ConfiguredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invoice_reader_not_configured(inputs)
	return fr_api_invoice_reader_not_configured(inputs)
});